import script from "./DefaultTransactionConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultTransactionConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultTransactionConfirm.vue?vue&type=style&index=0&id=4dd41e39&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd41e39"]])

export default __exports__